import React from "react";
import { Props } from "react-select";

import { RawSelectField } from "./RawSelectField";
import { FormikSelectField } from "./FormikSelectField";

type IProps = Props & {
  name?: string;
};

export const SelectField: React.FunctionComponent<IProps> = ({
  value,
  onBlur,
  onChange,
  components,
  options,
  classes,
  isClearable = false,
  isMulti = false,
  isDisabled = false,
  margin = "dense",
  inFormik,
  form,
  field,
  name,
  ...props
}: IProps) => {
  const isFormikConnected = form && field;
  if (isFormikConnected) {
    return (
      <FormikSelectField
        onBlur={onBlur}
        onChange={onChange}
        components={components}
        options={options}
        classes={classes}
        isClearable={isClearable}
        isMulti={isMulti}
        isDisabled={isDisabled}
        margin={margin}
        name={field.name}
        {...props}
      />
    );
  }
  return (
    <RawSelectField
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      components={components}
      options={options}
      classes={classes}
      isClearable={isClearable}
      isMulti={isMulti}
      isDisabled={isDisabled}
      margin={margin}
      {...props}
    />
  );
};
